module.exports = "<div (click)=\"appBackdropClose()\" [ngClass]=\"{ 'appBackdrop':isApp_BackdropVisible}\"></div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/app_backdrop/app_backdrop.component.html
// module id = ./src/app/shared/components/app_backdrop/app_backdrop.component.html
// module chunks = main